import {Grid, Typography} from '@mui/material';

import {BreakdownItem} from './AnalyticsSection';
import {orangeColors} from '../../../../layouts/theme/designSystem';

interface Props {
  items: BreakdownItem[];
}

export const AnalyticsBreakdownList = ({items}: Props) => {
  return (
    <Grid container sx={{marginTop: 2}}>
      {items.map((item, index) => (
        <Grid
          item
          container
          xs={12}
          key={index}
          sx={{
            padding: 2,
            backgroundColor: '#fff',
            borderRadius: '8px',
            border: '1px solid',
            borderColor: orangeColors[3],
            marginBottom: 1,
          }}
        >
          <Grid item xs={4}>
            <Typography variant='body1'>{item.label}</Typography>
          </Grid>
          <Grid item xs={4} textAlign='center'>
            -
          </Grid>
          <Grid item xs={4} textAlign='right'>
            <Typography variant='body1'>{item.value}</Typography>
          </Grid>
        </Grid>
      ))}
    </Grid>
  );
};
